import React from 'react';
import { Target, MessageSquare, Users } from 'lucide-react';
export function TeamPerformanceWidget() {
  // Mock data
  const performanceData = {
    objectivesCompletion: 78,
    oneOnOneCompletion: 85,
    feedbackFrequency: 1.2
  };
  return <div className="bg-white rounded-lg shadow-sm p-5 col-span-1" data-id="element-2129">
      <div className="flex items-center justify-between mb-4" data-id="element-2130">
        <h3 className="font-semibold text-gray-900" data-id="element-2131">Performance d'équipe</h3>
        <Target className="h-5 w-5 text-blue-600" data-id="element-2132" />
      </div>
      <div className="space-y-4" data-id="element-2133">
        <div data-id="element-2134">
          <div className="flex justify-between mb-1" data-id="element-2135">
            <span className="text-sm font-medium text-gray-700" data-id="element-2136">
              Objectifs alignés
            </span>
            <span className="text-sm font-medium text-gray-700" data-id="element-2137">
              {performanceData.objectivesCompletion}%
            </span>
          </div>
          <div className="w-full bg-gray-200 rounded-full h-2.5" data-id="element-2138">
            <div className="bg-blue-600 h-2.5 rounded-full" style={{
            width: `${performanceData.objectivesCompletion}%`
          }} data-id="element-2139"></div>
          </div>
        </div>
        <div data-id="element-2140">
          <div className="flex justify-between mb-1" data-id="element-2141">
            <span className="text-sm font-medium text-gray-700" data-id="element-2142">1:1 tenus</span>
            <span className="text-sm font-medium text-gray-700" data-id="element-2143">
              {performanceData.oneOnOneCompletion}%
            </span>
          </div>
          <div className="w-full bg-gray-200 rounded-full h-2.5" data-id="element-2144">
            <div className="bg-purple-600 h-2.5 rounded-full" style={{
            width: `${performanceData.oneOnOneCompletion}%`
          }} data-id="element-2145"></div>
          </div>
        </div>
        <div data-id="element-2146">
          <div className="flex justify-between mb-1" data-id="element-2147">
            <span className="text-sm font-medium text-gray-700" data-id="element-2148">
              Fréquence feedback
            </span>
            <span className="text-sm font-medium text-gray-700" data-id="element-2149">
              {performanceData.feedbackFrequency}/mois
            </span>
          </div>
          <div className="w-full bg-gray-200 rounded-full h-2.5" data-id="element-2150">
            <div className="bg-yellow-500 h-2.5 rounded-full" style={{
            width: `${performanceData.feedbackFrequency / 1.5 * 100}%`
          }} data-id="element-2151"></div>
          </div>
        </div>
      </div>
      <div className="mt-4 flex justify-between" data-id="element-2152">
        <button className="flex items-center text-sm text-blue-600 font-medium" data-id="element-2153">
          <Users className="h-4 w-4 mr-1" data-id="element-2154" />
          Détails par membre
        </button>
        <button className="flex items-center text-sm text-blue-600 font-medium" data-id="element-2155">
          <Target className="h-4 w-4 mr-1" data-id="element-2156" />
          Alignement
        </button>
      </div>
    </div>;
}